import schoollogo from '../../Assets/schoollogo.jpeg';
import collegelogo from '../../Assets/collegelogo.png';
import companylogo from '../../Assets/comapnylogo.png';
import Conestogalogo from '../../Assets/conestogalogo.jpg';


  export  const markers = [
        {
            id: 1,
            img: Conestogalogo,
            pos: 45,
            left: 440,
            title:'Conestoga – Data Preprocessing & Reporting',
            description:'Currently pursuing a Postgraduate Diploma in Data Preprocessing and Reporting. Focused on transforming raw data into actionable insights through cleaning, structuring, and visualization, complementing my AI and ML background.'
        },
        {
            id: 2,
            img: Conestogalogo,
            pos: 130,
            left: 500,
            title:'Conestoga – Applied AI and ML',
            description:'Completed a Postgraduate Diploma in Applied AI & ML, gaining hands-on expertise in machine learning, predictive modeling, and intelligent systems. Strengthened ability to apply AI/ML techniques to real-world applications.',
        },
        {
            id: 3,
            img: companylogo,
            pos: 230,
            left: 520,
            title:'Sequoia Consulting Group',
            description:'Worked as a Software Developer Intern for one year. Collaborated across teams, contributed to projects at every stage from design to production, and delivered reliable solutions, gaining valuable industry exposure and teamwork experience.'
        },
        {
            id: 4,
            img: collegelogo,
            pos: 330,
            left: 510,
            title:'Chitkara University',
            description:'Graduated with a BE in Computer Science and an outstanding 9.96/10 GPA. Secured an on-campus internship and developed strong technical expertise, preparing for a successful professional career in software and AI.'
        },
        {
            id: 5,
            img: schoollogo,
            pos: 430,
            left: 460,
            title:'DAV Public School',
            description:'Completed 12th in Non-Medical (Science) with excellent grades, securing 98% in Mathematics. Built a strong foundation in logical thinking and problem-solving, sparking my interest in technology and programming.'
        },

    ];